import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../../../components/Navbar/ui/Error";
import Loading from "../../../components/Navbar/ui/Loading";
import { useGetProjectsQuery } from "../../../features/projects/projectApi";
import {
  useEditTaskMutation,
  useGetTaskQuery,
} from "../../../features/tasks/tasksApi";
import { useGetTeamMembersQuery } from "../../../features/teamMembers/teamMembersApi";
const initialValues = {
  taskName: "",
  teamMember: "",
  project: "",
  deadline: "",
};

export default function EditForm() {
  const { taskId } = useParams();

  const { data: task, isSuccess: isSuccessTask } = useGetTaskQuery(taskId);

  console.log("task:: ", task);

  const [
    editTask,
    {
      isSuccess: editTaskIsSuccess,
      isLoading: editTaskIsLoading,
      isError: editTaskIsError,
    },
  ] = useEditTaskMutation();

  const {
    data: projects,
    isLoading: isLoadingProjects,
    isSuccess: isSuccessProjects,
    isError: isErrorProjects,
  } = useGetProjectsQuery();
  const {
    data: teamMembers,
    isLoading: isLoadingTeamMems,
    isSuccess: isSuccessTeamMembers,
    isError: isErrorTeamMems,
  } = useGetTeamMembersQuery();

  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    if (isSuccessTask) {
      setValues({
        taskName: task.taskName,
        teamMember: task.teamMember.id,
        project: task.project.id,
        deadline: task.deadline,
      });
    }
  }, [isSuccessTask, task]);

  useEffect(() => {
    if (editTaskIsLoading) {
    } else if (editTaskIsSuccess) {
      navigate("/");
      resetForm();
    } else if (editTaskIsError) {
    }
  }, [editTaskIsSuccess, editTaskIsLoading, editTaskIsError, navigate]);

  function resetForm() {
    setValues({});
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSuccessTeamMembers && isSuccessProjects) {
      const teamMember = teamMembers.find((t) => t.id === +values.teamMember);
      const project = projects.find((p) => p.id === +values.project);
      editTask({
        data: {
          ...values,
          project,
          teamMember: teamMember,
        },
        id: taskId,
      });
    }
  };

  // Decided what to render for ***TeamMembers***
  let contentTeamMembers = null;
  if (isLoadingTeamMems) {
    contentTeamMembers = <Loading />;
  } else if (!isLoadingTeamMems && isErrorTeamMems) {
    contentTeamMembers = (
      <Error header="Error!!" message="Fetching TeamMembers" />
    );
  } else if (
    !isLoadingTeamMems &&
    !isErrorTeamMems &&
    teamMembers?.length > 0
  ) {
    contentTeamMembers = (
      <select
        name="teamMember"
        id="lws-teamMember"
        required
        value={values.teamMember}
        onChange={handleChange}
      >
        <option value="" hidden>
          Select Job
        </option>
        {teamMembers.map((teamMember) => (
          <option key={teamMember.id} value={teamMember.id}>
            {teamMember.name}
          </option>
        ))}
      </select>
    );
  }

  // Decided what to render for ***Projects***
  let contentProject = null;
  if (isLoadingProjects) {
    contentProject = <Loading />;
  } else if (!isLoadingProjects && isErrorProjects) {
    contentProject = <Error header="Error!!" message="Fetching TeamMembers" />;
  } else if (!isLoadingProjects && !isErrorProjects && projects?.length > 0) {
    contentProject = (
      <select
        id="lws-projectName"
        name="project"
        required
        value={values.project}
        onChange={handleChange}
      >
        <option value="" hidden>
          Select Project
        </option>
        {projects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.projectName}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Update Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={values.taskName}
                onChange={handleChange}
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              {contentTeamMembers}
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              {contentProject}
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={values.deadline}
                onChange={handleChange}
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit ct-btn">
                Update
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
